export default {
    data: () => ({
        consumerModel: {
            phone: '',
            firstname: '',
            lastname: '',
            email: '',
            birthdate: '',
            iqonnect: '',
            zipcode: '',
            city: '',
            device: '',
            referer: '',
            gender: '',
            observations: '',
            contactEmail: ''
        }
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/consumerModel.js